import { I18n } from '@/i18n/I18n';
import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';

function ImageModal(props: {
  imagePath: string;
  setShowImageModal: (b: boolean) => void;
}) {
  const { imagePath, setShowImageModal } = props;

  return (
    <Modal show onHide={() => setShowImageModal(false)} fullscreen>
      <Modal.Header closeButton/>
      <Modal.Body className="d-flex">
        <img src={imagePath} alt="Full Size" className='image-fluid' style={{ width: '95vw', height: '90vh', objectFit: 'contain'}}  />
      </Modal.Body>
    </Modal>
  );
}

export function ExpandableImage({ src, alt, hideFilePreview = false }: { src: string, alt: string, hideFilePreview?: boolean }) {
  const [showImageModal, setShowImageModal] = useState(false);

  if (hideFilePreview) {
    return (
      <>
        <button className='btn btn-primary text-nowrap btn-sm my-auto' type='button' onClick={() => setShowImageModal(true)}>{I18n.get('viewFile')}</button>
        { showImageModal && (
          <ImageModal imagePath={src} setShowImageModal={setShowImageModal} />
        )}
      </>
    );
  }

  return (
    <>
      <div className="image-container">
        <img
          src={src}
          alt={alt}
          className="max-w-75 fit-content py-2"
          onClick={() => setShowImageModal(true)}
          style={{ cursor: 'pointer' }}
        />
      </div>

      {showImageModal && !hideFilePreview && (
        <ImageModal imagePath={src} setShowImageModal={setShowImageModal} />
      )}
    </>
  );
}
